/**
 * SecureServiceComponent Stateless Component
 */
import { CardState } from "containers/Card/store/CardState";
import * as React from "react";
import {
  LocalizeContextProps,
  Translate,
  withLocalize,
} from "react-localize-redux";
import { PopoverBody, PopoverHeader } from "reactstrap";
/**
 * SecureServiceComponent Stateless Component
 */
export class HowItWorksComponent extends React.Component<
  CardState & LocalizeContextProps,
  object
> {
  constructor(props: CardState & LocalizeContextProps) {
    super(props);
  }

  public render(): React.ReactNode {
    return (
      <div>
        <PopoverHeader>
          <Translate id={"howItWorks"} />
        </PopoverHeader>
        <PopoverBody>
          <div style={{ textAlign: "left", fontSize: "12px" }}>
            <Translate id={"helpText"} />
          </div>
          <div style={{ textAlign: "center", fontSize: "12px" }}>
            <hr />
            <strong>
              <Translate id={"exampleText.forExample"} />
            </strong>
            <ul>
              {this._examplesComponent("$1.15 USD", "1 1 5")}
              <br />
              <br />
              {this._examplesComponent("$450 COP", "4 5 0")}
            </ul>
            <br />
            <br />
          </div>
        </PopoverBody>
      </div>
    );
  }

  private _examplesComponent(value: string, code: string): JSX.Element {
    return (
      <li>
        <strong>-</strong>
        <Translate id={"exampleText.firstPhrase"} /> <strong>{value}</strong>
        <Translate id={"exampleText.secondPhrase"} /> <strong>{code}</strong>
      </li>
    );
  }
}

const HowItWorks: React.ComponentType = withLocalize<LocalizeContextProps>(
  HowItWorksComponent
);

export { HowItWorks };



// WEBPACK FOOTER //
// ./src/components/WaitingView/HowItWorksComponent.tsx